import { render } from "./Fusion_Treatments.vue?vue&type=template&id=f9475408"
import script from "./Fusion_Treatments.vue?vue&type=script&lang=js"
export * from "./Fusion_Treatments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__